import React, { useState, useEffect } from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';

/**
 * PieChartComponent for displaying categorical data in a pie chart
 * Simplified version without Collapse/Card wrapper for Observatory dashboard
 */
const PieChartComponent = ({ data, title = "Category Distribution", showLabels = true, colors }) => {
  
// Better format numbers with commas (handles decimals properly)
const formatNumber = (number) => {
  // Split into integer and decimal parts
  const parts = number.toString().split('.');
  // Add commas to integer part only
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  // Rejoin with decimal
  return parts.join('.');
};

  
  // Generate colors for pie slices
  const generateColors = (count) => {
    const colors = [];
    for (let i = 0; i < count; i++) {
      const hue = (i * 360) / count;
      colors.push(`hsl(${hue}, 70%, 60%)`);
    }
    return colors;
  };
  
// Custom tooltip
const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const data = payload[0];
    // Pie chart is always for cost distribution, so always show $
    const isCost = title?.toLowerCase().includes('cost');
    
    return (
      <div style={{
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        padding: '10px',
        borderRadius: '4px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <p style={{ margin: 0, fontWeight: 'bold' }}>{data.name}</p>
        <p style={{ margin: 0 }}>Value: {isCost ? '$' : ''}{formatNumber(data.value.toFixed(4))}</p>
        <p style={{ margin: 0 }}>Percentage: {((data.value / data.payload.total) * 100).toFixed(1)}%</p>
      </div>
    );
  }
  return null;
};
  
  // Extract metadata from data if available
  const chartSubtitle = data?.metadata?.subtitle || '';
  
  // Prepare chart data
  const chartData = data?.chartData || [];
  const total = chartData.reduce((sum, item) => sum + item.value, 0);
  const dataWithTotal = chartData.map(item => ({ ...item, total }));
  const pieColors = (colors && colors.length) ? colors : generateColors(chartData.length);
  
  return (
    <div style={{ width: '100%' }}>
      {/* Chart Subtitle */}
      {chartSubtitle && (
        <div style={{ 
          color: '#8c8c8c', 
          marginBottom: '16px',
          fontSize: '14px'
        }}>
          {chartSubtitle}
        </div>
      )}
      
      {/* Pie Chart */}
      <div style={{ width: '100%', height: '400px' }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={dataWithTotal}
              cx="50%"
              cy="50%"
              labelLine={false}
              outerRadius={120}
              fill="#8884d8"
              dataKey="value"
              label={showLabels ? ({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%` : false}
            >
              {dataWithTotal.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={pieColors[index % pieColors.length]} />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default PieChartComponent;